import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import BvBtn from 'volta/components/bv-btn';
import BvText from 'volta/components/bv-text';
import orElse from 'volta/helpers/or-else';
import type { TOC } from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';
import type { Dropdown } from 'ember-basic-dropdown/components/basic-dropdown';
export interface BvPopoverHeaderSignature {
    Args: {
        popover?: Dropdown;
        showCloseButton?: boolean;
        title?: ContentValue;
    };
    Blocks: {
        default: [popover?: Dropdown];
    };
    Element: HTMLElement;
}
const BvPopoverHeaderComponent: TOC<BvPopoverHeaderSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <header class='bv-popover__header' ...attributes>
    {{#if @title}}
      <BvText @variant='heading-sm' @text={{@title}} />
    {{/if}}
    {{yield @popover}}
    {{#if (orElse @showCloseButton true)}}
      <BvBtn
        class='bv-popover__close u-ml-2'
        @subtle={{true}}
        @rounded={{true}}
        @iconLeft='close'
        @size='sm'
        @onClick={{@popover.actions.close}}
      />
    {{/if}}
  </header>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvPopoverHeaderComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvPopover::Header': typeof BvPopoverHeaderComponent;
        'bv-popover/header': typeof BvPopoverHeaderComponent;
    }
}
